import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 7C4EED9D-D897-4B8C-9C0B-FE9A9D820A2D
 * name folder-network
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-network.svg
 * tags
 * - Files / Folders 
 */
export const FolderNetworkIcon = createSvgIcon(<><path d="M3,15V5A2,2 0 0,1 5,3H11L13,5H19A2,2 0 0,1 21,7V15A2,2 0 0,1 19,17H13V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H5A2,2 0 0,1 3,15Z" /></>, 'FolderNetworkIcon');
export default FolderNetworkIcon